/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */

export type EvaluationThumbsAnswer = typeof EvaluationThumbsAnswer[keyof typeof EvaluationThumbsAnswer];


export const EvaluationThumbsAnswer = {
  ThumbsDown: 'ThumbsDown',
  ThumbsUp: 'ThumbsUp',
} as const;
